import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import * as getters from './getters';
import * as actions from './actions';
import mutations from './mutations';

Vue.use(Vuex);

const state = {
  game: {
    points: [],
    labels: [],
    manualLabels: {},
    hitsList: {},
    gameInfo: {
      matchCnt: 3,
      matchName: '練習試合',
      player1Name: '選手1',
      player2Name: '選手2',
      player1Game: 0,
      player2Game: 0,
      player1Hand: 0,
      player2Hand: 0,
      firstGameServer: 0, // 0 or 1 or 2
      isRealTime: false,
      linkShareFlg: false,
      publicShareFlg: false,
      memoFlg: false,
      memo: '',
    },
    status: 10,
    createDate: undefined,
    updateDate: undefined,
    isProMode: false,
  },
  user: {
    signIn: false,
    uid: '',
    redirect: false,
  },
  app: {
    docId: undefined,
    loading: false,
    message: '',
  },
};

export default new Vuex.Store({
  state,
  mutations,
  getters,
  actions,
  strict: false,
  plugins: [createPersistedState({
    key: 'datapingpong',
    paths: ['game', 'user.signIn', 'user.uid', 'app.docId'],
  }), createPersistedState({
    key: 'datapingpong',
    paths: ['app.loading', 'app.message', 'user.redirect'],
    storage: window.sessionStorage,
  })],
});



// WEBPACK FOOTER //
// ./src/vuex/store.js